const styles = theme => ({
  recentFilesContainer: {
    marginTop: 0,
  },
  files: {
    display: 'flex',
    flexDirection: 'column',

    gap: 8,
    marginTop: 8,
  },
  file: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
    alignItems: 'flex-start',
    gap: 8,
    padding: 8,
    borderRadius: 8,
    background: '#ffffff',
    cursor: 'pointer',
    '&:hover': {
      background: '#F4F6F8',
      '&:hover svg': {
        color: '#015FFB',
      },
    },
  },
  fileIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
    color: '#919EAB',
    marginTop: 4,
  },
  fileName: {
    color: '#282F35',
    textOverflow: 'ellipsis',
    fontFamily: 'Inter',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
  },
  fileDescription: {
    color: '#919EAB',
    textOverflow: 'ellipsis',
    fontFamily: 'Inter',
    fontSize: 11,
    fontStyle: 'normal',
    fontWeight: 400,
  },
})

export default styles
